import {Api} from "@/repository/api";

export class SelectRepository extends Api {
    constructor() {
        super("core/select");
    }
}